import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

export default {
	/*----------------
	* ファイルアップローダのコールバック
	**/
	fileUploaderCallbacks: {
		begin($form, opt, vuwFileUploader) {
			const vuwForm = this.getForm();
			const data = {
				sheet: vuwForm.getActiveSheet().name,
				dataType: vuwFileUploader.dataType
			};
			
			if(	vuwForm.enableAddExecModeParam &&
					!u_.hasProperty($form.get(0), vuwForm.execModeParamName)
			) {
				// modeパラメータがない場合は付与する
				data[vuwForm.execModeParamName] = vuwForm.execModeValues.file;
			}
			
			!vuwFileUploader.hiddenInps && (vuwFileUploader.hiddenInps = {});
			Object.keys(data).forEach(k => {
				if(!vuwFileUploader.hiddenInps[k]) {
					vuwFileUploader.hiddenInps[k] = $("<input/>").attr({
						type: "hidden",
						name: k
					}).appendTo($form).get(0);
				}
				
				vuwFileUploader.hiddenInps[k].value = data[k];
			});
		},
		
		async onError(err) {
			const vuwForm = this.getForm();
			
			if( u_.isString(err) ) {
				await vuwForm.alert(err);
			} else
			if( u_.isObject(err) ) {
				if( !u_.isString(err.type) && !isNaN(err.code) ) {
					err.type = String(err.code);
				}
				if(typeof err.messages !== "object") {
					err.messages = u_.isString(err.messages) ? [err.messages] : [];
				}
				
				if( u_.isFunction( vuwForm.errorCallbacks[err.type] ) ) {
					await vuwForm.errorCallbacks[err.type].apply(vuwForm, [
						err.messages,
						err.methodName,
						err.code,
						err.type
					]);
				} else {
					await vuwForm.errorCallbacks.def.apply(vuwForm, [
						err.messages,
						err.methodName,
						err.code,
						err.type
					]);
				}
			}
			
			if( u_.isFunction(vuwForm.fileFieldCallbacks.onError) ) {
				await vuwForm.fileFieldCallbacks.onError.call(vuwForm, err);
			}
			
			return err;
		},
		
		onSelect(selectedFilePath, selectedFileName) {
			const vuwForm = this.getForm();
			if( u_.isFunction(vuwForm.fileFieldCallbacks.onSelect) ) {
				vuwForm.fileFieldCallbacks.onSelect.apply(vuwForm, arguments);
			}
		},
		
		onDisSelect(paramKey) {
			const vuwForm = this.getForm();
			if( u_.isFunction(vuwForm.fileFieldCallbacks.onDisSelect) ) {
				vuwForm.fileFieldCallbacks.onDisSelect.apply(vuwForm, arguments);
			}
		},
		
		onFileRead(ulFile, content) {
			const vuwForm = this.getForm();
			if( u_.isFunction(vuwForm.fileFieldCallbacks.onFileRead) ) {
				vuwForm.fileFieldCallbacks.onFileRead.apply(vuwForm, arguments);
			}
		},
		
		onUpload(res) {
			const vuwForm = this.getForm();
			if( u_.isFunction(vuwForm.fileFieldCallbacks.onUpload) ) {
				vuwForm.fileFieldCallbacks.onUpload.apply(vuwForm, arguments);
			}
		}
	}
};
